
import React, { Component } from 'react';
import {getMainCookie,checkStatus} from '../../../../util/util';

let token;
class TrackDetailAlert extends Component {
    constructor() {
        super();
        this.state  = {
            carAlertList : [],

        };
    }
    componentDidMount(){
        let alertConfig  = getMainCookie();
        token = alertConfig.token;
    }

    callCheckAlert(device_id){
        let thisCur = this;
        fetch("http://203.150.199.244/api/report/getTrackerEventAlert", {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token":token
                },
            body: JSON.stringify({ 
                "devices": [{"device_id": device_id}], 
                "getNotify" : true, 
                "allAlertType": true,
                "filter": "" 
            })
        }).then(function(response) {
            return checkStatus(response);
        }).then((data) =>{
            console.log("data",data)
            if(!data && !data.RESULT_DATA && data.RESULT_DATA.length==0)
                return;
            if(data.RESULT_DATA)
                thisCur.setState({carAlertList : data.RESULT_DATA[0]});
            
        }, 
        (error) => {
          console.log("error",error)
          return error;
        }
            
        )
        
        
    }

    render() {
        let rows = [];
        if (this.state.carAlertList && this.state.carAlertList.alert) {
            this.state.carAlertList.alert.map((carAlert, index) => {

                rows.push(<tr style={{ height: 25 }} key={index} id={"carAlertRow" + index} className="carAlertRow">
                    <td >{index + 1}</td>
                    <td >{carAlert.device_no}</td>
                    <td >{carAlert.alert_type}</td>
                    <td style={{ textAlign: "center" }}>{carAlert.date}</td>
                    <td style={{ textAlign: "center" }}>{carAlert.time}</td>
                </tr>)
            })
        }
        return (
            <div className="row table-responsive" style={{ backgroundColor: "#fff" }}>
                <table class="table table-hover table-striped ">
                    <thead>
                        <tr style={{ textAlign: "center" }}>
                            <th >#</th>
                            <th >ทะเบียน</th>
                            <th >สถานะ</th>
                            <th >วันที่</th>
                            <th >เวลา</th>
                        </tr>
                    </thead>
                    <tbody>
                        {

                            rows

                        }



                    </tbody>
                </table>
            </div>


        );
    }
}
export default TrackDetailAlert;


// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/TrackDetailAlert/TrackDetailAlert.js